import { Type, InjectionToken, Injectable } from '@angular/core';

import { throwError, Observable } from 'rxjs';

import { RequestErrorHandler, TokenService } from './models';

@Injectable()
export class NoopTokenService implements TokenService {
  getToken(): string | null {
    return null;
  }
}

@Injectable()
export class NoopRequestErrorHandler implements RequestErrorHandler {
  handle(error: any): Observable<any> {
    return throwError(() => error);
  }
}

export class WebsocketsOptions {
  debug?: boolean;
}

export const defaultOptions = {
  debug: false,
};

export interface WebsocketsModuleConfig {
  tokenService: Type<TokenService>;
  requestErrorHandler?: Type<RequestErrorHandler>;
  options?: WebsocketsOptions;
}

export const TOKEN_SERVICE = new InjectionToken<TokenService>('TOKEN_SERVICE');
export const REQUEST_ERROR_HANDLER = new InjectionToken<RequestErrorHandler>('REQUEST_ERROR_HANDLER');
export const NEW_OPTIONS: InjectionToken<string> = new InjectionToken('NEW_OPTIONS');
export const DEFAULT_OPTIONS: InjectionToken<WebsocketsOptions> = new InjectionToken('DEFAULT_OPTIONS');
